// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-catalog-sidebar[data-v-5b4207b6]{--lorgar-color-global-tertiary:#c162fb}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
